export default "__VITE_ASSET__DiPJ8Ybz__"